import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  media: []
};

const getMedia = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_LOADING:
      return Object.assign({}, state, {
        loading: true
      });
    case CONSTANTS.GET_MEDIA:
      return Object.assign({}, state, {
        loading: false,
        media: action.media
      });

    default:
      return state;
  }
};
export default getMedia;
